
import { userData } from "services/LoginFunctions"

const URL_API_GeradorDoc = "https://documentosemurb.souzatech.net/";
const URL_API_CalcTax = "https://emurbdc.souzatech.tech/api-calculadora/";
const URL_API_BDFuncionario = "https://logintaxasemurb.souzatech.net";
const URL_API_Correios = "https://viacep.com.br"

const HTTP_METHODS = {GET: "GET", POST: "POST", PUT: "PUT", DELETE: "DELETE"}
const APIS = {CORREIOS: URL_API_Correios, DORA: URL_API_CalcTax, GERADOC: URL_API_GeradorDoc, LOGIN: URL_API_BDFuncionario}

async function callEndpoint(api, httpMethod, endpoint, bodyData, setShowMessages, authorization = false)
{
    console.log('URL API Tax:', process.env.REACT_APP_URL_API_CalcTax);
    console.log('URL API Func:', process.env.REACT_APP_URL_API_BDFuncionario);

    if (!Object.values(APIS).includes(api)) { console.log(`Erro ao tentar chamar api: api ${api} não existe`) ; return }
    if (!Object.values(HTTP_METHODS).includes(httpMethod)) { console.log(`Erro ao tentar chamar api: método HTTP ${httpMethod} não existe`) ; return }

    if (httpMethod === HTTP_METHODS.POST && !bodyData) { console.log("Aviso: chamando um método POST com body indefinido") }
    
    const url = api + endpoint
    const reqOpts =
    {
        method: httpMethod,
        headers:
        {
            "Content-Type": "application/json",
            "Authorization": authorization ? "Bearer " + userData().token : ""
        },
        body: JSON.stringify(bodyData)
    }
    var response
    try
    {
        console.log(`Chamando ${api}${endpoint}`)
        response = await fetch(url, reqOpts)
        
        console.log(response)
        if (setShowMessages && setShowMessages.success) { setShowMessages.success(true) }

    }
    catch(error)
    {
        if (setShowMessages && setShowMessages.error) { setShowMessages.error(true) }
        console.log(`Erro ao chamar o endpoint: ${error}`)
        throw error
    }

    if (response?.ok)
    {
        return response
    }
    else
    {
        const erro = await response.text()
        throw new Error(erro)
    }

}

export function downloadDocument(data, filename)
{
    // creates a pdf url, sets it as the target of an invisible link, clicks the link and then removes it
    const url = window.URL.createObjectURL(data)
    const phantomLink = document.createElement('a')
    phantomLink.style.display = 'none'
    phantomLink.href = url
    phantomLink.download = filename + ".pdf"
    document.body.appendChild(phantomLink)
    phantomLink.click()
    document.body.removeChild(phantomLink)
    window.URL.revokeObjectURL(url)
}

export async function GetAdressFromCEP(cep)
{
    const cleanCep = cep.replace('.', '').replace('-', '')
    return (await callEndpoint(APIS.CORREIOS, HTTP_METHODS.GET, `/ws/${cleanCep}/json/`)).json()
}

//#region  Calculadora de taxas 

export async function CheckHealthDora()
{
    return await callEndpoint(APIS.DORA, HTTP_METHODS.GET, "getVersion")
}

export async function CalcTax(idServ, inputData, version, setShowMessages)
{
    try 
    {
        const result = await callEndpoint(APIS.DORA, HTTP_METHODS.POST, `calc${idServ}${version}`, inputData, setShowMessages)
        return result.json()
    }
    catch (error)
    {
        return {"error": error.message}
    }
}

//#endregion  Calculadora de taxas 

//#region  Login de funcionários 

export async function CheckHealthLogin()
{
    return await callEndpoint(APIS.LOGIN, HTTP_METHODS.GET, `/healthCheck`)
}

export async function PegarTodosFuncionarios()
{
    return (await callEndpoint(APIS.LOGIN, HTTP_METHODS.GET, `/getAll`)).json()
}

export async function AddPermissao(data, setShowError)
{
    return (await callEndpoint(APIS.LOGIN, HTTP_METHODS.POST, `/addRole`, data)).json()
}

export async function RemoverPermissao(data, setShowError)
{
    return (await callEndpoint(APIS.LOGIN, HTTP_METHODS.POST, `/removeRole`, data)).json()
}

export async function AlterarSenhaParaTemporaria(data, setShowError)
{
    return await callEndpoint(APIS.LOGIN, HTTP_METHODS.POST, `/updatePasswordToTemp`, data, null, true)
}

export async function AlterarSenha(data, setShowError)
{
    return await callEndpoint(APIS.LOGIN, HTTP_METHODS.POST, `/updatePassword`, data, null, true)
}

export async function ValidateLoginFuncionario(loginData, setShowError)
{
    const { matricula, senha } = loginData
    const bodyData = { "matricula": matricula, "senha": senha }
    return (await callEndpoint(APIS.LOGIN, HTTP_METHODS.POST, `/api/auth/signin`, bodyData)).json()
}

export async function CadastrarUsuario(data, setShowError)
{
    return (await callEndpoint(APIS.LOGIN, HTTP_METHODS.POST, `/signup`, data)).json()
}

//#endregion  Login de funcionários 

//#region  Gerador de documentos 

export async function CheckHealthGeradoc()
{
    return await callEndpoint(APIS.GERADOC, HTTP_METHODS.GET, "Tests/HealthCheck")
}

// export async function CheckDocsFuncionandoGeradoc()
// {
//     return await callEndpoint(APIS.GERADOC, HTTP_METHODS.GET, "Tests/TodosOsDocumentosFuncionando")
// }

export async function GerarDoc(input, filename, numProc, anoProc, baixarDoc = false, setShowMessages)
{
// TODO melhorar msg de erro ao passar processo não existente aqui
    if (!input.tipoDoc) { console.log("Erro: Tentando gerar documento sem tipo doc") ; return }

    const incluirSubTipo = input.tipoDoc.startsWith("Alvara") || input.tipoDoc.startsWith("Anuencia") || input.tipoDoc === "CertRegul" || input.tipoDoc.startsWith("Habitese")
    const subTipoURL = incluirSubTipo ? `&subTipoDoc=${input.subTipoDoc}` : ""
    const numProcURL = numProc ? `&numProc=${numProc}` : ""
    const anoProcURL = anoProc ? `&anoProc=${anoProc}` : ""
    try
    {
        const pdfData = await callEndpoint(APIS.GERADOC, HTTP_METHODS.POST, `GerarDoc/GerarDocComBDBody?tipoDoc=${input.tipoDoc}${subTipoURL}${numProcURL}${anoProcURL}`, input, setShowMessages, false)
        if (baixarDoc)
        {
            pdfData.blob().then(data => downloadDocument(data, filename))
            return pdfData
        }
        return pdfData
    }
    catch (error)
    {
        return {"error": error.message}
    }
}

export async function BaixarDocFromID(idProc, idDoc, filename, baixarDoc, setShowMessages)
{
    const pdfData = await callEndpoint(APIS.GERADOC, HTTP_METHODS.PUT, `api/Processo/BaixarDocumentoPorID?idProc=${idProc}&idDoc=${idDoc}`, undefined, setShowMessages, false)
    if (baixarDoc)
    {
        pdfData.blob().then(data => downloadDocument(data, filename))
    }
    return pdfData.blob().then(data => {return data})
}

export async function BaixarMultaFromID(idMulta, filename, baixarMulta, setShowMessages)
{
    const pdfData = await callEndpoint(APIS.GERADOC, HTTP_METHODS.PUT, `api/Multa/BaixarPeloID?idMulta=${idMulta}`, undefined, setShowMessages, false)
    if (baixarMulta)
    {
        pdfData.blob().then(data => downloadDocument(data, filename))
    }
    return pdfData.blob().then(data => {return data})
}

export async function CriarProcessoVazio(numProcStr)
{
    const strSplt = numProcStr.split('/')
    const numProc = strSplt[0]
    const anoProc = strSplt[1]
    const bodyData = {"numProc": numProc, "anoProc": anoProc, "matriculaCriador": userData().matricula}
    return (await callEndpoint(APIS.GERADOC, HTTP_METHODS.POST, `api/Processo/SalvarNovo`, bodyData)).json()
}

//#endregion  Gerador de documentos 

//#region  Registro de documentos 

export async function PegarProcessosPagBD(filtros=null)
{
    return (await callEndpoint(APIS.GERADOC, HTTP_METHODS.POST, `api/Processo/PegarProcessosPag`, filtros)).json()
}

export async function PegarProcesso(numProc, anoProc)
{
    const response = await callEndpoint(APIS.GERADOC, HTTP_METHODS.GET, `api/Processo/PegarPeloNumero?numProc=${numProc}&anoProc=${anoProc}`, undefined, undefined, false)
    if (response.status !== 204)
    {
        return response.json()
    }
}

export async function PegarProcessoPorID(idProc)
{
    return (await callEndpoint(APIS.GERADOC, HTTP_METHODS.GET, `api/Processo/PegarPeloID?idProc=${idProc}`)).json()
}

export async function SalvarDocumento(numProc, anoProc, documentData, autoNumerar)
{
    const response = await callEndpoint(APIS.GERADOC, HTTP_METHODS.POST, `api/Processo/AddDocumento?numProc=${numProc}&anoProc=${anoProc}&autoNumerar=${autoNumerar}`, documentData)
    if (!response.ok) throw new Error("Problema na resposta do request")
    return response.json()
}

export async function SalvarEGerarDocumento(numProc, anoProc, documentData, filename)
{

    if (!documentData.tipoDoc) { console.log("Erro: Tentando gerar documento sem tipo doc") ; return }

    const autoNumerar = documentData.autoNumerar
    const response = await callEndpoint(APIS.GERADOC, HTTP_METHODS.POST, `api/Processo/AddEGerarDocumento?numProc=${numProc}&anoProc=${anoProc}&autoNumerar=${autoNumerar}`, documentData)
    
    if (!response.ok) throw new Error("Problema na resposta do request")

    const pdfData = response.blob().then(data => downloadDocument(data, filename))
    return pdfData

}

export async function SalvarDocumentoCriarProcesso(numProc, anoProc, documentData, filename, baixarDoc = true)
{
    try
    {
        const response = await callEndpoint(APIS.GERADOC, HTTP_METHODS.POST, `api/Processo/AddDocumentoAndCreateProcesso?numProc=${numProc}&anoProc=${anoProc}`, documentData)
        if (baixarDoc)
        {
            const dadosResposta = response.blob().then(data => { downloadDocument(data, filename) ; return data})
            return dadosResposta
        }
        return response.blob().then(data => {return data})
    }
    catch (error)
    {
        return {"error": error.message}
    }
}

export async function EditarDocumento(idProc, idDoc, documentData, filename, baixarDoc = true)
{
    try
    {
        const response = await callEndpoint(APIS.GERADOC, HTTP_METHODS.PUT, `api/Processo/AtualizarDocumentoPorID?idProc=${idProc}&idDoc=${idDoc}`, documentData, undefined, false)
        if (baixarDoc)
        {
            response.blob().then(data => downloadDocument(data, filename))
            return {}
        }
        return response.json()
    }
    catch (error)
    {
        return {"error": error.message}
    }
}

export async function PegarTodasMultas()
{
    return (await callEndpoint(APIS.GERADOC, HTTP_METHODS.GET, `api/Multa/PegarTodos`)).json()
}

export async function AtualizarMulta(idMulta, docBodyDB)
{
    return (await callEndpoint(APIS.GERADOC, HTTP_METHODS.PUT, `api/Multa/Atualizar?idMulta=${idMulta}`, docBodyDB)).text()
}

export async function SalvarMulta(docBodyDB)
{
    return (await callEndpoint(APIS.GERADOC, HTTP_METHODS.POST, `api/Multa/SalvarNovo`, docBodyDB)).json()
}

export async function oficializarDocumentoPorID(idProc, idDoc)
{
    return await callEndpoint(APIS.GERADOC, HTTP_METHODS.PUT, `api/Processo/OficializarDocumentoPorID?idProc=${idProc}&idDoc=${idDoc}`, undefined, undefined, false)
}

export async function oficializarMulta(numMulta, anoMulta)
{
    return await callEndpoint(APIS.GERADOC, HTTP_METHODS.PUT, `api/Multa/Oficializar?numDoc=${numMulta}&anoDoc=${anoMulta}`, undefined, undefined, false)
}

export async function excluirMulta(idMulta)
{
    return await callEndpoint(APIS.GERADOC, HTTP_METHODS.DELETE, `api/Multa/Deletar?idMulta=${idMulta}`, undefined, undefined, false)
}

export async function excluirDocumentoPorID(idProc, idDoc)
{
    return await callEndpoint(APIS.GERADOC, HTTP_METHODS.DELETE, `api/Processo/DeletarDocumentoPorID?idProc=${idProc}&idDoc=${idDoc}`, undefined, undefined, false)
}

//#endregion  Registro de documentos 


//#region Registro de processos


//#endregion  Registro de documentos 

// #region Levantamentos

export async function QtdDocumentosPorTipo()
{
    return (await callEndpoint(APIS.GERADOC, HTTP_METHODS.GET, `api/Levantamentos/QtdDocumentosPorTipo`)).json()
}

export async function QtdDocumentosPorDia(considerarGuias)
{
    return (await callEndpoint(APIS.GERADOC, HTTP_METHODS.GET, `api/Levantamentos/QtdDocumentosPorDia?considerarGuias=${considerarGuias}`)).json()
}

export async function ArrecadacaoMensal()
{
    const mesAtual = new Date().getMonth() + 1
    const anoAtual = new Date().getFullYear()
    const dataInicio = `${anoAtual}-${mesAtual}-01T00%3A00%3A00`
    const dataFim = `${anoAtual}-${mesAtual}-31T00%3A00%3A00`
    return (await callEndpoint(APIS.GERADOC, HTTP_METHODS.GET, `api/Levantamentos/ArrecadacaoEntreDatas?dataInicio=${dataInicio}&dataFim=${dataFim}`)).json()
}